import { render, staticRenderFns } from "./Door_sensor.vue?vue&type=template&id=c2ff3196&scoped=true"
import script from "./Door_sensor.vue?vue&type=script&lang=js"
export * from "./Door_sensor.vue?vue&type=script&lang=js"
import style0 from "./Door_sensor.vue?vue&type=style&index=0&id=c2ff3196&prod&lng=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ff3196",
  null
  
)

export default component.exports